var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import { getWebMcpTools, registerWebMcpTools, destroy } from '../base/constant';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DialogRenderer } from '../renderer/dialog-renderer';
import { webMcpTools } from './webmcp-tools';
/**
 * WebMcpAdapter — Integrates RichTextEditor with WebMCP protocol.
 * Inject this module to enable AI tool execution capabilities.
 */
var WebMcpRichTextEditor = /** @class */ (function () {
    function WebMcpRichTextEditor(parent) {
        this.webMcpAbortController = null;
        this.parent = parent;
        this.addEventListener();
    }
    //  Attaches event listeners for WebMCP communication.
    WebMcpRichTextEditor.prototype.addEventListener = function () {
        this.parent.on(getWebMcpTools, this.getTools, this);
        this.parent.on(registerWebMcpTools, this.registerTools, this);
        this.parent.on(destroy, this.destroy, this);
    };
    // Removes event listeners when component is destroyed.
    WebMcpRichTextEditor.prototype.removeEventListener = function () {
        this.parent.off(getWebMcpTools, this.getTools);
        this.parent.off(registerWebMcpTools, this.registerTools);
        this.parent.off(destroy, this.destroy);
    };
    // Retrieves available tools, optionally filtered by names.
    WebMcpRichTextEditor.prototype.getTools = function (args) {
        var toolNames = args.toolNames;
        if (toolNames && toolNames.length !== 0) {
            args.tools = webMcpTools.filter(function (webMcpTool) { return toolNames.indexOf(webMcpTool.name) !== -1; })
                .map(function (webMcpTool) { return (__assign({}, webMcpTool)); });
        }
        else {
            args.tools = webMcpTools.map(function (webMcpTool) { return (__assign({}, webMcpTool)); });
        }
        return args.tools;
    };
    // Registers tools with document.modelContext for AI access.
    WebMcpRichTextEditor.prototype.registerTools = function (args) {
        var _this = this;
        var modelContext = document.modelContext;
        if (!modelContext || typeof modelContext.registerTool !== 'function') {
            return;
        }
        this.webMcpAbortController = new AbortController();
        var toolPrefix = (isNullOrUndefined(args.prefix) ? this.parent.element.id : args.prefix);
        var tools = args.tools && args.tools.length && typeof args.tools[0] === 'object' ? args.tools :
            this.getTools({ toolNames: args.tools });
        tools.forEach(function (tool) {
            tool.name = toolPrefix + "_" + tool.name;
            tool.execute = tool.execute || (function (args) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHandler(tool.name, args || {})];
            }); }); });
            var registerOptions = {
                signal: _this.webMcpAbortController.signal
            };
            if (Array.isArray(args.exposedTo) && args.exposedTo.length > 0) {
                registerOptions.exposedTo = args.exposedTo;
            }
            modelContext.registerTool(tool, registerOptions);
        });
    };
    //  Executes a WebMCP tool handler based on command name.
    //  Fires beforeWebMcpToolExecute event for cancellation/confirmation.
    WebMcpRichTextEditor.prototype.executeHandler = function (command, args) {
        return __awaiter(this, void 0, void 0, function () {
            var baseCommand, eventArgs, _a, type, dialogType, summary, approved, type, dialogType, summary, approved, payload, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, summary, approved, toolDefinition, isWriteOperation, summary, approved;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        baseCommand = command.includes('_') ? command.substring(command.indexOf('_') + 1) : command;
                        eventArgs = { toolName: command, toolArgs: args };
                        this.parent.trigger('beforeWebMcpToolExecute', eventArgs);
                        // Check if tool execution was cancelled
                        if (eventArgs.cancel) {
                            return [2 /*return*/, this.message({
                                    action: command,
                                    cancelled: true,
                                    message: eventArgs.cancellationResponse ||
                                        "[USER_CANCELLED] Tool \"" + command + "\" was cancelled. This is final. Do NOT retry."
                                })];
                        }
                        _a = baseCommand;
                        switch (_a) {
                            case 'getContent': return [3 /*break*/, 1];
                            case 'getSelectedHtml': return [3 /*break*/, 2];
                            case 'selectAllContent': return [3 /*break*/, 3];
                            case 'showDialog': return [3 /*break*/, 4];
                            case 'closeDialog': return [3 /*break*/, 6];
                            case 'insertContent': return [3 /*break*/, 8];
                            case 'formatSelectedContent': return [3 /*break*/, 10];
                            case 'setBlockType': return [3 /*break*/, 12];
                            case 'setTextAlignment': return [3 /*break*/, 14];
                            case 'insertLink': return [3 /*break*/, 16];
                            case 'insertTable': return [3 /*break*/, 18];
                            case 'insertImage': return [3 /*break*/, 20];
                            case 'undoLastAction': return [3 /*break*/, 22];
                            case 'redoLastAction': return [3 /*break*/, 24];
                            case 'clearFormatting': return [3 /*break*/, 26];
                            case 'printContent': return [3 /*break*/, 28];
                            case 'setCodeBlock': return [3 /*break*/, 29];
                            case 'applyNumberedListFormat': return [3 /*break*/, 31];
                            case 'applyBulletedListFormat': return [3 /*break*/, 33];
                            case 'insertBR': return [3 /*break*/, 35];
                        }
                        return [3 /*break*/, 37];
                    case 1: return [2 /*return*/, this.handleGetContent(args)];
                    case 2: return [2 /*return*/, this.handleGetSelectedHtml(args)];
                    case 3: return [2 /*return*/, this.handleSelectAllContent(args)];
                    case 4:
                        type = args.type;
                        dialogType = type;
                        if (dialogType === 'InsertImage' && (isNOU(this.parent.imageModule))) {
                            return [2 /*return*/, this.error('Image module is not injected. Please inject the Image module to use this dialog.')];
                        }
                        if (dialogType === 'InsertTable' && (isNOU(this.parent.tableModule))) {
                            return [2 /*return*/, this.error('Table module is not injected. Please inject the Table module to use this dialog.')];
                        }
                        if (dialogType === 'InsertLink' && (isNOU(this.parent.linkModule))) {
                            return [2 /*return*/, this.error('Link module is not injected. Please inject the Link module to use this dialog.')];
                        }
                        if (dialogType === 'InsertAudio' && (isNOU(this.parent.audioModule))) {
                            return [2 /*return*/, this.error('Audio module is not injected. Please inject the Audio module to use this dialog.')];
                        }
                        if (dialogType === 'InsertVideo' && (isNOU(this.parent.videoModule))) {
                            return [2 /*return*/, this.error('Video module is not injected. Please inject the Video module to use this dialog.')];
                        }
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 5:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleShowDialog(args)];
                    case 6:
                        type = args.type;
                        dialogType = type;
                        if (dialogType === 'InsertImage' && (isNOU(this.parent.imageModule))) {
                            return [2 /*return*/, this.error('Image module is not injected. Please inject the Image module to use this dialog.')];
                        }
                        if (dialogType === 'InsertTable' && (isNOU(this.parent.tableModule))) {
                            return [2 /*return*/, this.error('Table module is not injected. Please inject the Table module to use this dialog.')];
                        }
                        if (dialogType === 'InsertLink' && (isNOU(this.parent.linkModule))) {
                            return [2 /*return*/, this.error('Link module is not injected. Please inject the Link module to use this dialog.')];
                        }
                        if (dialogType === 'InsertAudio' && (isNOU(this.parent.audioModule))) {
                            return [2 /*return*/, this.error('Audio module is not injected. Please inject the Audio module to use this dialog.')];
                        }
                        if (dialogType === 'InsertVideo' && (isNOU(this.parent.videoModule))) {
                            return [2 /*return*/, this.error('Video module is not injected. Please inject the Video module to use this dialog.')];
                        }
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 7:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleCloseDialog(args)];
                    case 8:
                        payload = args;
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 9:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleInsertContent(args)];
                    case 10:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 11:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleFormatSelectedContent(args)];
                    case 12:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 13:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleSetBlockType(args)];
                    case 14:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 15:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleSetTextAlignment(args)];
                    case 16:
                        // Check if Link module is injected
                        if (isNOU(this.parent.linkModule)) {
                            return [2 /*return*/, this.error('Link module is not injected. Please inject the Link module to use this tool.')];
                        }
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 17:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleInsertLink(args)];
                    case 18:
                        // Check if Table module is injected
                        if (isNOU(this.parent.tableModule)) {
                            return [2 /*return*/, this.error('Table module is not injected. Please inject the Table module to use this tool.')];
                        }
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 19:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleInsertTable(args)];
                    case 20:
                        // Check if Image module is injected
                        if (isNOU(this.parent.imageModule)) {
                            return [2 /*return*/, this.error('Image module is not injected. Please inject the Image module to use this tool.')];
                        }
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 21:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleInsertImage(args)];
                    case 22:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 23:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleUndoLastAction(args)];
                    case 24:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 25:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleRedoLastAction(args)];
                    case 26:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 27:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleClearFormatting(args)];
                    case 28: return [2 /*return*/, this.handlePrintContent(args)];
                    case 29:
                        if (isNOU(this.parent.codeBlockModule)) {
                            return [2 /*return*/, this.error('CodeBlock module is not injected. Please inject the CodeBlock module to use this tool.')];
                        }
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 30:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleSetCodeBlock(args)];
                    case 31:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 32:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleApplyNumberedListFormat(args)];
                    case 33:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 34:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleApplyBulletedListFormat(args)];
                    case 35:
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 36:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        return [2 /*return*/, this.handleInsertBR(args)];
                    case 37:
                        toolDefinition = webMcpTools.find(function (tool) { return tool.name === baseCommand; });
                        isWriteOperation = toolDefinition && toolDefinition.annotations &&
                            toolDefinition.annotations.readOnlyHint === false;
                        if (!isWriteOperation) return [3 /*break*/, 39];
                        summary = this.buildConfirmationMessage(baseCommand, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand, args, summary)];
                    case 38:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand,
                                    cancelled: true,
                                    message: "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        _b.label = 39;
                    case 39: return [2 /*return*/, this.error("Tool \"" + baseCommand + "\" not found.")];
                }
            });
        });
    };
    // Removes event listeners and cleanup.
    WebMcpRichTextEditor.prototype.destroy = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.removeEventListener();
        if (this.webMcpAbortController) {
            this.webMcpAbortController.abort();
            this.webMcpAbortController = null;
        }
    };
    // Returns module name for identification.
    WebMcpRichTextEditor.prototype.getModuleName = function () {
        return 'WebMcpRichTextEditor';
    };
    //  Formats successful response in WebMCP standard format.
    WebMcpRichTextEditor.prototype.message = function (data) {
        return { content: [{ type: 'text', text: JSON.stringify(data) }] };
    };
    //  Formats error response in WebMCP standard format.
    WebMcpRichTextEditor.prototype.error = function (text) {
        return { content: [{ type: 'text', text: text }], isError: true };
    };
    //  Build human-readable confirmation message for write operations.
    WebMcpRichTextEditor.prototype.buildConfirmationMessage = function (command, args) {
        return "Confirm: " + command;
    };
    // Request user confirmation before executing write operations.
    WebMcpRichTextEditor.prototype.requestConfirmation = function (command, args, message) {
        return __awaiter(this, void 0, void 0, function () {
            var parentElement;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.parent.isDestroyed || !this.parent.element || !this.parent.rootContainer) {
                    return [2 /*return*/, true];
                }
                parentElement = this.parent.element;
                return [2 /*return*/, new Promise(function (resolve) {
                        try {
                            var msg = message || _this.buildConfirmationMessage(command, args);
                            var renderer = new DialogRenderer(_this.parent);
                            var dialogEle_1 = _this.parent.createElement('div', {
                                className: 'e-webmcp-confirm-wrapper'
                            });
                            _this.parent.rootContainer.appendChild(dialogEle_1);
                            var dialogModel = {
                                header: 'AI Action Request',
                                content: msg,
                                cssClass: 'e-webmcp-confirm-dlg',
                                enableRtl: _this.parent.enableRtl || false,
                                showCloseIcon: true,
                                isModal: true,
                                width: '375px',
                                position: { X: 'center', Y: 'top' },
                                target: parentElement,
                                buttons: [
                                    {
                                        buttonModel: { content: 'Ok', isPrimary: true },
                                        click: function () {
                                            dialogInst_1.hide();
                                            dialogInst_1.destroy();
                                            dialogEle_1.remove();
                                            resolve(true);
                                        }
                                    },
                                    {
                                        buttonModel: { content: 'Cancel' },
                                        click: function () {
                                            dialogInst_1.hide();
                                            dialogInst_1.destroy();
                                            dialogEle_1.remove();
                                            resolve(false);
                                        }
                                    }
                                ],
                                close: function () {
                                    resolve(false);
                                    if (dialogInst_1) {
                                        dialogInst_1.hide();
                                        dialogInst_1.destroy();
                                        dialogEle_1.remove();
                                    }
                                }
                            };
                            var dialogInst_1 = renderer.render(dialogModel);
                            dialogInst_1.createElement = _this.parent.createElement;
                            dialogInst_1.appendTo(dialogEle_1);
                            dialogInst_1.show();
                        }
                        catch (error) {
                            resolve(true);
                        }
                    })];
            });
        });
    };
    // Tool handler methods
    WebMcpRichTextEditor.prototype.handleGetContent = function (args) {
        var content = this.parent.value;
        return this.message({
            success: true,
            data: { content: content || '' },
            message: 'Successfully retrieved content'
        });
    };
    WebMcpRichTextEditor.prototype.handleGetSelectedHtml = function (args) {
        var selectedHtml = this.parent.getSelectedHtml();
        return this.message({
            success: true,
            data: { selectedHtml: selectedHtml || '' },
            message: 'Successfully retrieved selected HTML'
        });
    };
    WebMcpRichTextEditor.prototype.handleSelectAllContent = function (args) {
        this.parent.selectAll();
        return this.message({
            success: true,
            message: 'Successfully selected all content'
        });
    };
    WebMcpRichTextEditor.prototype.handleShowDialog = function (args) {
        var type = args.type;
        var dialogType = type;
        this.parent.showDialog(dialogType);
        return this.message({
            success: true,
            message: "Successfully showed " + type + " dialog"
        });
    };
    WebMcpRichTextEditor.prototype.handleCloseDialog = function (args) {
        var type = args.type;
        var dialogType = type;
        this.parent.closeDialog(dialogType);
        return this.message({
            success: true,
            message: "Successfully closed " + type + " dialog"
        });
    };
    WebMcpRichTextEditor.prototype.handleInsertContent = function (args) {
        var content = args.content, contentType = args.contentType;
        if (contentType === 'text') {
            this.parent.executeCommand('insertText', content, { undo: true });
        }
        else {
            this.parent.executeCommand('insertHTML', content, { undo: true });
        }
        return this.message({
            success: true,
            message: 'Successfully inserted content'
        });
    };
    WebMcpRichTextEditor.prototype.handleFormatSelectedContent = function (args) {
        var formatType = args.formatType, fontfamily = args.fontfamily, fontsize = args.fontsize, backgroundcolor = args.backgroundcolor, fontcolor = args.fontcolor;
        // Handle value-based formatting
        switch (formatType) {
            case 'fontfamily':
                if (fontfamily) {
                    this.parent.executeCommand('fontName', fontfamily, { undo: true });
                }
                break;
            case 'fontsize':
                if (fontsize) {
                    this.parent.executeCommand('fontSize', fontsize, { undo: true });
                }
                break;
            case 'backgroundcolor':
                if (backgroundcolor) {
                    this.parent.executeCommand('backColor', backgroundcolor, { undo: true });
                }
                break;
            case 'fontcolor':
                if (fontcolor) {
                    this.parent.executeCommand('fontColor', fontcolor, { undo: true });
                }
                break;
            default:
                // Handle toggle-based formatting
                this.parent.executeCommand(formatType, null, { undo: true });
                break;
        }
        return this.message({
            success: true,
            message: "Successfully applied " + formatType + " formatting"
        });
    };
    WebMcpRichTextEditor.prototype.handleSetBlockType = function (args) {
        var blockType = args.blockType;
        if (blockType.startsWith('H')) {
            this.parent.executeCommand('heading', blockType, { undo: true });
        }
        else {
            this.parent.executeCommand('formatBlock', blockType, { undo: true });
        }
        return this.message({
            success: true,
            message: "Successfully set block type to " + blockType
        });
    };
    WebMcpRichTextEditor.prototype.handleSetTextAlignment = function (args) {
        var alignment = args.alignment;
        var commandName = alignment;
        this.parent.executeCommand(commandName, null, { undo: true });
        return this.message({
            success: true,
            message: "Successfully set text alignment to " + alignment
        });
    };
    WebMcpRichTextEditor.prototype.handleInsertLink = function (args) {
        var url = args.url, text = args.text, title = args.title, target = args.target;
        var linkArgs = { url: url, text: text, title: title, target: target };
        this.parent.executeCommand('createLink', linkArgs, { undo: true });
        return this.message({
            success: true,
            message: 'Successfully inserted link'
        });
    };
    WebMcpRichTextEditor.prototype.handleInsertTable = function (args) {
        // Default to a 3x3 table when the caller omits dimensions.
        var rows = isNOU(args.rows) ? 3 : Number(args.rows);
        var columns = isNOU(args.columns) ? 3 : Number(args.columns);
        // Fall back to defaults when the values are invalid (per schema bounds).
        if (isNaN(rows) || rows < 1 || rows > 100) {
            rows = 3;
        }
        if (isNaN(columns) || columns < 1 || columns > 50) {
            columns = 3;
        }
        // Fall back to the editor's tableSettings when the optional width model is omitted or partial.
        var rawWidth = (args.width && typeof args.width === 'object') ? args.width : {};
        var widthModel = {
            width: !isNOU(rawWidth.width) ? rawWidth.width : this.parent.tableSettings.width,
            minWidth: !isNOU(rawWidth.minWidth) ? rawWidth.minWidth : this.parent.tableSettings.minWidth,
            maxWidth: !isNOU(rawWidth.maxWidth) ? rawWidth.maxWidth : this.parent.tableSettings.maxWidth
        };
        var currentSelection = this.parent.formatter.editorManager.nodeSelection;
        var tableArgs = { rows: rows, columns: columns, width: widthModel, selection: currentSelection };
        this.parent.executeCommand('insertTable', tableArgs, { undo: true });
        return this.message({
            success: true,
            data: { rows: rows, columns: columns },
            message: "Successfully inserted " + rows + "x" + columns + " table"
        });
    };
    WebMcpRichTextEditor.prototype.handleInsertImage = function (args) {
        var url = args.url, altText = args.altText, width = args.width, height = args.height, cssClass = args.cssClass;
        var imageArgs = { url: url, altText: altText, width: width, height: height, cssClass: cssClass };
        this.parent.executeCommand('insertImage', imageArgs, { undo: true });
        return this.message({
            success: true,
            message: 'Successfully inserted image'
        });
    };
    WebMcpRichTextEditor.prototype.handleUndoLastAction = function (args) {
        this.parent.executeCommand('undo');
        return this.message({
            success: true,
            message: 'Successfully undid last action'
        });
    };
    WebMcpRichTextEditor.prototype.handleRedoLastAction = function (args) {
        this.parent.executeCommand('redo');
        return this.message({
            success: true,
            message: 'Successfully redid last action'
        });
    };
    WebMcpRichTextEditor.prototype.handleClearFormatting = function (args) {
        this.parent.executeCommand('removeFormat', null, { undo: true });
        return this.message({
            success: true,
            message: 'Successfully cleared formatting'
        });
    };
    WebMcpRichTextEditor.prototype.handlePrintContent = function (args) {
        this.parent.print();
        return this.message({
            success: true,
            message: 'Successfully initiated print'
        });
    };
    WebMcpRichTextEditor.prototype.handleSetCodeBlock = function (args) {
        var language = args.language, label = args.label;
        var codeBlockArgs = { language: language, label: label };
        this.parent.executeCommand('insertCodeBlock', codeBlockArgs, { undo: true });
        return this.message({
            success: true,
            message: "Successfully inserted code block with " + label + " syntax highlighting"
        });
    };
    WebMcpRichTextEditor.prototype.handleApplyNumberedListFormat = function (args) {
        var style = args.style;
        // Then apply the specific numbering style
        this.parent.executeCommand('numberFormatList', style, { undo: true });
        return this.message({
            success: true,
            message: "Successfully applied numbered list format: " + style
        });
    };
    WebMcpRichTextEditor.prototype.handleApplyBulletedListFormat = function (args) {
        var style = args.style;
        // Then apply the specific bullet style
        this.parent.executeCommand('bulletFormatList', style, { undo: true });
        return this.message({
            success: true,
            message: "Successfully applied bulleted list format: " + style
        });
    };
    WebMcpRichTextEditor.prototype.handleInsertBR = function (args) {
        this.parent.executeCommand('insertBrOnReturn', null, { undo: true });
        return this.message({
            success: true,
            message: 'Successfully inserted line break'
        });
    };
    return WebMcpRichTextEditor;
}());
export { WebMcpRichTextEditor };
